/**
 * @fileoverview Finance API service methods for ClubOS
 */
import apiClient from "../client";

export const financeService = {
  // ── Summary ──────────────────────────────────────────────────────────────
  getSummary: () => apiClient.get("/finance/summary"),

  // ── Contracts ─────────────────────────────────────────────────────────────
  getContracts: (params) => apiClient.get("/finance/contracts", { params }),
  getContract: (id) => apiClient.get(`/finance/contracts/${id}`),
  createContract: (data) => apiClient.post("/finance/contracts", data),
  updateContract: (id, data) => apiClient.put(`/finance/contracts/${id}`, data),
  terminateContract: (id) => apiClient.delete(`/finance/contracts/${id}`),

  // ── Transfers ─────────────────────────────────────────────────────────────
  getTransfers: (params) => apiClient.get("/finance/transfers", { params }),
  createTransfer: (data) => apiClient.post("/finance/transfers", data),
  approveTransfer: (id, approvalLevel) =>
    apiClient.put(`/finance/transfers/${id}/approve`, { approvalLevel }),
  cancelTransfer: (id, reason = "Cancelled") =>
    apiClient.delete(`/finance/transfers/${id}`, { params: { reason } }),

  // ── Financial Records (Revenue / Ledger) ─────────────────────────────────
  getRecords: (params) => apiClient.get("/finance/records", { params }),
  createRecord: (data) => apiClient.post("/finance/records", data),

  // ── Department Budgets ────────────────────────────────────────────────────
  getDepartmentBudgets: (fiscalYear) =>
    apiClient.get("/finance/budgets", { params: fiscalYear ? { fiscalYear } : {} }),
  upsertDepartmentBudget: (data) => apiClient.put("/finance/budgets", data),
  deleteDepartmentBudget: (id) => apiClient.delete(`/finance/budgets/${id}`),

  // ── Staff Contracts ───────────────────────────────────────────────────────
  getStaffContracts: (params) => apiClient.get("/finance/staff-contracts", { params }),
  createStaffContract: (data) => apiClient.post("/finance/staff-contracts", data),
  updateStaffContract: (id, data) => apiClient.put(`/finance/staff-contracts/${id}`, data),
  terminateStaffContract: (id) => apiClient.delete(`/finance/staff-contracts/${id}`),

  // ── Sponsorships ──────────────────────────────────────────────────────────
  getSponsorships: (params) => apiClient.get("/finance/sponsorships", { params }),
  createSponsorship: (data) => apiClient.post("/finance/sponsorships", data),
  updateSponsorship: (id, data) => apiClient.put(`/finance/sponsorships/${id}`, data),
  closeSponsorship: (id, closeType, reason) =>
    apiClient.put(`/finance/sponsorships/${id}/close`, { closeType, reason }),

  // ── Matchday Revenue ──────────────────────────────────────────────────────
  getMatchdayRevenue: (params) => apiClient.get("/finance/matchday", { params }),
  createMatchdayRevenue: (data) => apiClient.post("/finance/matchday", data),
  updateMatchdayRevenue: (id, data) => apiClient.put(`/finance/matchday/${id}`, data),
  deleteMatchdayRevenue: (id) => apiClient.delete(`/finance/matchday/${id}`),

  // ── Expenses ──────────────────────────────────────────────────────────────
  getExpenses: (params) => apiClient.get("/finance/expenses", { params }),
  createExpense: (data) => apiClient.post("/finance/expenses", data),
  updateExpense: (id, data) => apiClient.put(`/finance/expenses/${id}`, data),
  deleteExpense: (id) => apiClient.delete(`/finance/expenses/${id}`),
  approveExpense: (id) => apiClient.put(`/finance/expenses/${id}/approve`),
};
